import React, { useMemo } from "react";
import PropTypes from "prop-types";
import styles from "./styles.m.css";
import { DeepBI } from "../../../integrations";

const AppInstallPopup = ({ setShowInstallPopup }) => {
  const osType = useMemo(() => {
    // Only access navigator on client-side
    if (typeof window === "undefined" || typeof navigator === "undefined") {
      return "other"; // fallback for SSR
    }

    const ua = window.navigator.userAgent || window.navigator.vendor || window.opera;

    if (/android/i.test(ua)) return "android";
    if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return "ios";

    return "other";
  }, []);

  const handleOpenApp = () => {
    DeepBI.PingLoginevents("Install_App_Open_Click");
    window.open("https://onelink.to/rnz428", "_blank");
    setShowInstallPopup(false);
  };

  const handleContinue = () => {
    DeepBI.PingLoginevents("Install_App_Continue_Browser_Click");
    setShowInstallPopup(false);
  };

  const handleClose = () => {
    DeepBI.PingLoginevents("Install_App_Close_Click");
    setShowInstallPopup(false);
  };

  React.useEffect(() => {
    DeepBI.PingLoginevents("Install_App_Popup_Display");
  }, []);

  return (
    <div className={styles["install-app-popup-overlay"]}>
      <div className={styles["install-app-popup"]}>
        <button className={styles["close-btn"]} onClick={handleClose}>
          <img
            src="https://media.vikatan.com/vikatan/2025-10-03/pco573q3/app-install-close.png?q=100&w=28"
            alt="Close"
          />
        </button>
        <div className={styles["app-info-details"]}>
          <div className={styles["install-app-header"]}>Go to Vikatan App</div>
          <div className={styles["install-app-content"]}>
            <img
              src="https://media.vikatan.com/vikatan/2026-01-09/su7egkh9/android-chrome-192x192.png?q=100&w=48"
              alt="Vikatan App"
              className={styles["app-icon"]}
            />
            <div className={styles["app-details"]}>
              <div className={styles["app-name"]}>Vikatan App</div>
            </div>
            <button className={styles["open-btn"]} onClick={handleOpenApp}>
              Open
            </button>
          </div>
          <div className={styles["app-meta"]}>
            <span className={styles["app-rating"]}>
              <strong>4.7★</strong>
              <br /> 46.5k reviews
            </span>
            <span className={styles["app-downloads"]}>
              <strong>3M+</strong> <br />
              Downloads
            </span>
            <span className={styles["app-age"]}>
              <strong className={styles["border-text"]}>3+</strong> <br />
              Rated for 3+
            </span>
          </div>
        </div>
        <div className={styles["install-app-footer"]}>
          <img
            src={
              osType === "android"
                ? "https://media.vikatan.com/vikatan/2025-10-13/p2tapkxv/Chromeiconpng.png?q=100&w=65"
                : osType === "ios"
                  ? "https://media.vikatan.com/vikatan/2025-10-13/ej4bam66/Safariiconpng.png?q=100&w=65"
                  : "https://media.vikatan.com/vikatan/2025-10-03/3avc9bbq/continue-browser.png?q=100&w=65"
            }
            alt="Continue in Web Browser"
          />
          <span>Continue in Web Browser</span>
          <button className={styles["continue-btn"]} onClick={handleContinue}>
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

AppInstallPopup.propTypes = {
  setShowInstallPopup: PropTypes.func.isRequired
};

export default AppInstallPopup;
